import { render } from "./ExportDialog.vue?vue&type=template&id=8447f752"
import script from "./ExportDialog.vue?vue&type=script&lang=js"
export * from "./ExportDialog.vue?vue&type=script&lang=js"

import "./ExportDialog.vue?vue&type=style&index=0&id=8447f752&lang=css"
script.render = render

export default script